export default function getAnnotationBoundingBox(handlesObject) {
  let xStart = Infinity;
  let yStart = Infinity;
  let xEnd = 0;
  let yEnd = 0;

  const handleKeys = Object.keys(handlesObject);

  if (!handleKeys.length) {
    return;
  }

  handleKeys.forEach(handleKey => {
    if (handleKey === 'textBox') {
      return;
    }

    const handle = handlesObject[handleKey];
    const handlesUndefined = handle.x === undefined || handle.y === undefined;
    if (handlesUndefined) {
      return;
    }

    xStart = Math.min(xStart, handle.x);
    yStart = Math.min(yStart, handle.y);
    xEnd = Math.max(xEnd, handle.x);
    yEnd = Math.max(yEnd, handle.y);
  });

  xStart = xStart === Infinity ? 0 : xStart;
  yStart = yStart === Infinity ? 0 : yStart;

  return {
    xStart,
    yStart,
    xEnd,
    yEnd
  };
}
